// extracted by mini-css-extract-plugin
module.exports = {"discord":"Discord_discord__2PULp","discordBtn":"Discord_discordBtn__2JxiW"};